'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, stage_id, item) {
  return function (dispatch) {
    var itemType = item.placeholder ? 'placeholder' : 'event';

    return dispatch(_defineProperty({
      feis_id: feis_id,
      stage_id: stage_id,
      item: item

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisStagesPrefix)(feis_id) + '/' + stage_id + '/detach-' + itemType + '/' + item.id,
        method: 'DELETE'
      },
      types: ['DETACH_EVENT_FROM_STAGE_START', 'DETACH_EVENT_FROM_STAGE', 'DETACH_EVENT_FROM_STAGE_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/detachEvent.js
// module id = 243
// module chunks = 0